/* global Modal */

if (!customElements.get('return-modal')) {
    class ReturnModal extends HTMLElement {
        constructor() {
          super();
          this.documentClickHandler = this.handleDocumentClick.bind(this);
          this.keydownHandler = this.handleKeydown.bind(this);
          this.closeBtn = this.querySelector('.return-close');
          this.checkbox = this.querySelector('#return-agree');
          this.submitBtn = this.querySelector('#return-confirmed');
          this.opener = null;
          document.addEventListener("click", this.documentClickHandler);
          this.addEventListener('click', this.handleCloseClick);
          this.checkbox.addEventListener('change', this.handleCheckBoxClick.bind(this));
          // The proceed link is gated by the agreement box: while the box is unticked a click or Enter on it must not navigate.
          this.submitBtn.addEventListener('click', this.handleProceedClick.bind(this));
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.documentClickHandler);
          document.removeEventListener('keydown', this.keydownHandler);
        }

        handleDocumentClick(evt){
           const opener = evt.target.closest('#returnBtn');
           if(!opener) return;
           this.open(opener);
        }

        open(opener){
          this.opener = opener;
          this.style.display = "block";
          this.removeAttribute('aria-hidden');
          document.addEventListener('keydown', this.keydownHandler);
          if (this.closeBtn) this.closeBtn.focus();
        }

        close(){
          this.style.display = "none";
          this.setAttribute('aria-hidden', 'true');
          document.removeEventListener('keydown', this.keydownHandler);
          if (this.opener && this.opener.focus) this.opener.focus();
        }

        handleCloseClick(evt){
            if(!evt.target.closest('.return-close')) return;
            this.close();
        }

        handleKeydown(evt){
          if (evt.key === 'Escape') {
            evt.preventDefault();
            this.close();
            return;
          }
          if (evt.key !== 'Tab') return;
          // Keep Tab and Shift+Tab inside the dialog.
          const items = Array.from(this.querySelectorAll('button, a[href], input, select, textarea, [tabindex]'))
            .filter((el) => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length > 0);
          if (!items.length) { evt.preventDefault(); return; }
          const first = items[0];
          const last = items[items.length - 1];
          const active = document.activeElement;
          if (evt.shiftKey && (active === first || !this.contains(active) || active === this)) {
            evt.preventDefault();
            last.focus();
          } else if (!evt.shiftKey && (active === last || !this.contains(active))) {
            evt.preventDefault();
            first.focus();
          }
        }

        handleProceedClick(evt){
            if(this.submitBtn.getAttribute('aria-disabled') === 'true') evt.preventDefault();
        }

        handleCheckBoxClick(evt){
            if(!evt.target.matches('#return-agree')) return;
            if(this.checkbox.checked){
                this.submitBtn.removeAttribute("aria-disabled");
                this.submitBtn.removeAttribute("tabindex");
                this.submitBtn.style.pointerEvents = "all";
              }else{
                this.submitBtn.setAttribute("aria-disabled", "true");
                this.submitBtn.setAttribute("tabindex", "-1");
                this.submitBtn.style.pointerEvents = "none";
            }
        }
      }

      customElements.define('return-modal', ReturnModal);
  }